/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Pwa_ReloadInputs */

const es_pwa_reload = /** @type {(inputs: Pwa_ReloadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Recargar`)
};

const en_pwa_reload = /** @type {(inputs: Pwa_ReloadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Reload`)
};

/**
* | output |
* | --- |
* | "Reload" |
*
* @param {Pwa_ReloadInputs} inputs
* @param {{ locale?: "es" | "en" }} options
* @returns {LocalizedString}
*/
const pwa_reload = /** @type {((inputs?: Pwa_ReloadInputs, options?: { locale?: "es" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Pwa_ReloadInputs, { locale?: "es" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_pwa_reload(inputs)
	return en_pwa_reload(inputs)
});
export { pwa_reload as "pwa.reload" }